import { useState } from "react";
import styles from './ExamplesMenu.module.css';

const ExamplesMenu = ({ onExampleSelect, activeExample, isOpen: externalIsOpen, onToggle }) => {
  const [internalIsOpen, setInternalIsOpen] = useState(false);
  const isOpen = externalIsOpen !== undefined ? externalIsOpen : internalIsOpen;
  
  const handleToggle = () => {
    const newState = !isOpen;
    if (onToggle) {
      onToggle(newState);
    } else {
      setInternalIsOpen(newState);
    }
  };

  const examples = [
    {
      id: "abb-parks-3d",
      name: "ABB Parkları (3D)",
      description: "abb.geojson dosyası parkları - 3D",
      color: "#6a478f"
    },
    {
      id: "abb-parks-2d",
      name: "ABB Parkları (2D)",
      description: "abb.geojson dosyası parkları - 2D",
      color: "#1e6fa5"
    },
    {
      id: "population-2d",
      name: "Nüfus Verileri (2D)",
      description: "İl nüfuslarına göre renk kodlaması",
      color: "#c0392b"
    },
    {
      id: "population-3d",
      name: "Nüfus Verileri (3D)",
      description: "3D yükseklik efekti ile nüfus",
      color: "#6a478f"
    },
    {
      id: "rivers",
      name: "Nehir Ağları",
      description: "Nehir türüne göre renk ve kalınlık",
      color: "#2980b9"
    },
    {
      id: "parks-polygon",
      name: "Çokgen Parklar (2D)",
      description: "5gen, 6gen, 9gen, 20gen vs. çeşitli şekillerde parklar",
      color: "#16a085"
    },
    {
      id: "parks-3d",
      name: "Çokgen Parklar (3D)",
      description: "Çeşitli şekillerde 3D park alanları",
      color: "#d35400"
    },
    {
      id: "istanbul-parks-2d",
      name: "İstanbul Parkları (2D)",
      description: "Gülhane ve Yıldız Parkları - attribute'ları göster",
      color: "#16a085"
    },
    {
      id: "istanbul-parks-3d",
      name: "İstanbul Parkları (3D)",
      description: "Gülhane ve Yıldız Parkları 3D görünüm",
      color: "#c7522a"
    },
    {
      id: "ankara-parks-2d",
      name: "Ankara Parkları (2D)",
      description: "Yahya Kemal ve Tanzimat Parkları - 2D",
      color: "#138d75"
    },
    {
      id: "ankara-parks-3d",
      name: "Ankara Parkları (3D)",
      description: "Yahya Kemal ve Tanzimat Parkları - 3D",
      color: "#a93226"
    },
    {
      id: "ankara-parks-3d-short",
      name: "Ankara Parkları (3D Kısa)",
      description: "Ankara parkları - daha kısa 3D görünümü",
      color: "#c0392b"
    }
  ];

  return (
    <div className={styles.menuContainer}>
      <button 
        className={styles.menuButton}
        onClick={handleToggle}
      >
        📊 GIS
      </button>
      
      {isOpen && (
        <div className={styles.menuDropdown}>
          <div className={styles.menuHeader}>
          </div>
          
          <div className={styles.examplesList}>
            {examples.map(example => (
              <div
                key={example.id}
                className={`${styles.exampleItem} ${activeExample === example.id ? styles.active : ''}`}
                onClick={() => {
                  onExampleSelect(example.id);
                  if (onToggle) onToggle(false);
                  else setInternalIsOpen(false);
                }}
              >
                <div 
                  className={styles.exampleColor}
                  style={{ backgroundColor: example.color }}
                ></div>
                <div className={styles.exampleContent}>
                  <h4>{example.name}</h4>
                  <p>{example.description}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className={styles.menuFooter}>
            <p>Pronuve</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExamplesMenu;
